"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const translation_hooks_1 = require("@hooks/translation.hooks");
const user_hooks_1 = require("@hooks/user.hooks");
const token_icon_1 = require("@shared-modules/components/token-icon");
const number_1 = require("@utils/object/number");
const core_1 = require("@web3-react/core");
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
require("./styles.scss");
const ProfileStatsPage = () => {
    const { account } = (0, core_1.useWeb3React)();
    const { params: { id: profileAccount = account || "" }, } = (0, react_router_dom_1.useRouteMatch)();
    const translator = (0, translation_hooks_1.usePagesTranslation)("profileStatsPage");
    const tokenGetter = (0, tokens_reducer_1.useTokenGetter)();
    const { data: profileStats } = (0, user_hooks_1.useUserStatsByAccount)(profileAccount);
    const volumeStats = [
        {
            title: translator("buyVolumeTitle"),
            grid: profileStats === null || profileStats === void 0 ? void 0 : profileStats.buyVolume.map(({ paymentTokenAddress, volume }) => {
                const token = tokenGetter(paymentTokenAddress);
                return {
                    token,
                    volume,
                };
            }),
        },
        {
            title: translator("sellVolumeTitle"),
            grid: profileStats === null || profileStats === void 0 ? void 0 : profileStats.sellVolume.map(({ paymentTokenAddress, volume }) => {
                const token = tokenGetter(paymentTokenAddress);
                return {
                    token,
                    volume,
                };
            }),
        },
        {
            title: translator("overallVolumeTitle"),
            grid: profileStats === null || profileStats === void 0 ? void 0 : profileStats.overallVolume.map(({ paymentTokenAddress, volume }) => {
                const token = tokenGetter(paymentTokenAddress);
                return {
                    token,
                    volume,
                };
            }),
        },
    ];
    return (React.createElement("div", { className: "p-profile-stats-page" },
        React.createElement("div", { className: "p-profile-stats-page__section-title" }, translator("volumeStatsTitle")),
        React.createElement("div", { className: "p-profile-stats-page__section-sub-title" }, translator("nftsSoldLabel", { amount: profileStats === null || profileStats === void 0 ? void 0 : profileStats.nftSellCount })),
        React.createElement("div", { className: "p-profile-stats-page__volume" }, volumeStats.map(({ title, grid }) => {
            return (React.createElement("div", { className: "p-profile-stats-page__section-item", key: title },
                React.createElement("div", { className: "p-profile-stats-page__section-item-title" }, title),
                React.createElement("div", { className: "p-profile-stats-page__section-item-grid" }, grid === null || grid === void 0 ? void 0 : grid.map(({ token, volume }) => {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(token_icon_1.TokenIcon, { symbol: token === null || token === void 0 ? void 0 : token.symbol }),
                        React.createElement("div", null, token === null || token === void 0 ? void 0 : token.symbol),
                        React.createElement("div", { className: "p-profile-stats-page__section-item-volume" }, (0, number_1.formatAndNormalizeToken)(token, volume, token === null || token === void 0 ? void 0 : token.decimals))));
                }))));
        }))));
};
exports.default = ProfileStatsPage;
